export interface DeleteDefaultParameterOrderListRequest {
  id: string
  revision: number
}

export function DeleteDefaultParameterOrderListRequestToJSON(
  value: DeleteDefaultParameterOrderListRequest
): any {
  return {
    id: value.id ? value.id : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
